import React from 'react';
import styled from 'styled-components';

const MainSection = styled.section `
    height: calc(100vh - 110px); 
    width: 100%;
    min-width: 1080px;
    min-height: 720px;
    position: relative;
`;

const DefaultSection = styled.section`
    width: 100%;
    min-width: 1080px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 80px 30px 200px 30px;
    box-sizing: border-box;
`;

export default function Section(props) {
    if(props.type === 1) {
        return (
            <MainSection id={props.id} style={props.style}>{props.children}</MainSection>
        );
    }

    return (
        <DefaultSection id={props.id} style={props.style}>{props.children}</DefaultSection>
    );
};
